import React from 'react';
import DeckLogInspectorBackView from './deck/DeckLogInspectorBackView';
import { useParams } from 'react-router-dom';

type OwnProps = {
	bookId: string;
};
const LogModuleBack = (props: OwnProps) => {
	const params = useParams<{vesselId: string}>();
	const { vesselId } = params;
    const { bookId } = props;

    switch (bookId) {
        case 'deckLogConfig':
            return <DeckLogInspectorBackView vesselId={vesselId}/>;

        default:
            return null;
    }
};

export default LogModuleBack;